export enum OptionTypeEnum {
    CHECKBOX="checkbox",
    BULLET = "bullet",
    TEXTAREA ="textarea",
    BOOLEAN ="boolean"
}